import { useState } from 'react';
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager';
import { getDecodedHashParams } from '../utils/hashUtils';
import { CqItemsTabs } from '../../components/app/compound/Tabs/Tabs.types';
import { useLocationHash } from './useLocationParam';

export const TAB_URI_KEY = 'tab';

export const getActiveTabFromHash = (hash: string, items: CqItemsTabs): string | null => {
  const hashParams = getDecodedHashParams(hash);
  const value = hashParams.get(TAB_URI_KEY);

  return Object.entries(items).find(([, item]) => item['cq:panelTitle'] === value)?.[0] ?? null;
};

const useActiveTab = (
  items: CqItemsTabs,
  initial: string,
  updateHash: boolean = true,
): [string, (value: string) => void] => {
  const [hash, setHash] = useLocationHash();
  const [activeTab, setActiveTab] = useState(getActiveTabFromHash(hash, items) ?? initial);
  const isInEditor = AuthoringUtils.isInEditor();

  const handleUpdateHash = (hashTab: string) => {
    const hashParams = getDecodedHashParams(hash);
    hashParams.set(TAB_URI_KEY, hashTab);
    setHash(hashParams.toString());
  };

  const handleSetActiveTab = (tab: string) => {
    if (tab !== activeTab) {
      setActiveTab(() => tab);

      if (!isInEditor && updateHash) {
        const activeTabName = items[tab]['cq:panelTitle'];
        handleUpdateHash(activeTabName);
      }
    }
  };

  return [activeTab, handleSetActiveTab];
};

export default useActiveTab;
